import { render } from "./EnterAppointmentID.vue?vue&type=template&id=23dcd3c0&scoped=true"
import script from "./EnterAppointmentID.vue?vue&type=script&lang=js"
export * from "./EnterAppointmentID.vue?vue&type=script&lang=js"

import "./EnterAppointmentID.vue?vue&type=style&index=0&id=23dcd3c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dcd3c0"]])

export default __exports__